<template>
  <div class="save">
      <img width="92%" @click="gouploaderprogress" style="margin:20% 0 5% 0;" src="@/assets/uploader/onlyupload.png" alt="">
      <img width="92%" @click="goprogress" src="@/assets/uploader/uploadmore.png" alt="">

      <div class="tip">
        <p>温馨提示:</p>
        <div>您一共选择了<span style="color:#F7772B;">{{fileList.length}}</span>张图片，文件总大小为<span style="color:#185ED3;font-weight:600">{{fileSize}}M</span>，上传消耗对应流量，建 议在WIFI环境下操作。</div>
      </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import { createStore } from "@/store";
const store = createStore();
import { Toast } from 'vant'
export default {
  data(){
    return{
      fileList: this.$store.state.user.fileList,
      fileSize:0
    }
  },
  methods:{
    ...mapActions(["setIsUpload"]),
    goprogress(){
      this.$router.push({name:'progress',
        query:{
          token:store.state.user.token,
          date:store.state.user.expirationTime,
          createUid:store.state.user.createUid,
          powers:JSON.stringify(store.state.user.powers)
        }
      })
      localStorage.setItem('isUpload',false)
      this.setIsUpload(false)
    },
    gouploaderprogress(){
      this.$router.push({name:'uploadprocess',query: {
        isOnly:true,
        token:store.state.user.token,
        date:store.state.user.expirationTime,
        createUid:store.state.user.createUid,
        powers:JSON.stringify(store.state.user.powers)
      }})
      localStorage.setItem('isUpload',true)
      this.setIsUpload(true)
    },
    //base64转blob
    // dataURLtoBlob(dataurl) {
    //     var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
    //         bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    //     while (n--) {
    //         u8arr[n] = bstr.charCodeAt(n);
    //     }
    //     return new Blob([u8arr], { type: mime });
    // },
    //blob转file
    // blobToFile(newBlob, fileName) {
    //   newBlob.lastModifiedDate = new Date();
    //   newBlob.name = fileName;
    //   return newBlob;
    // },
  },
  created(){

    if(!this.fileList){
      Toast('图片获取失败,请重新选择！')
      let powers = this.$route.query.powers
      localStorage.setItem('isUpload',true)
      setTimeout(() => {
        this.$router.push({path:'/uploader',
          query:{
            token:this.$route.query.token,
            date:this.$route.query.expirationTime,
            createUid:this.$route.query.createUid,
            powers:powers
          }
        })
      }, 2000);
    }else{
      for (let i = 0; i < this.fileList.length; i++) {
        this.fileSize += this.fileList[i].file.size
      }
      this.fileSize = (this.fileSize / 1024 /1024).toFixed(2)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./save.scss";

</style>